export const KRONER_IMMEDIATE_DISPOSITION = {
  LC_Perm_RI_SPFU_BPI: 'LC_Perm_RI_SPFU_BPI',
  LC_Nuevas_Adv_BPI: 'LC_Nuevas_Adv_BPI',
  LC_Perm_RI_SPFU_Prem_BPI: 'LC_Perm_RI_SPFU_Prem_BPI',
  LC_Perm_RevIni_SPFU_BPI: 'LC_Perm_RevIni_SPFU_BPI',
};

export const REFILL_KRONER = {
  LC_Perm_RS_SPFU: 'LC_Perm_RS_SPFU',
  Sub_Rev_OH: 'Sub_Rev_OH',
  LC_Perm_RS_Adva_BPI: 'LC_Perm_RS_Adva_BPI',
  LC_Perm_RS_Premier_BPI: 'LC_Perm_RS_Premier_BPI',
  LC_Recom_Rev_Adva_BPI: 'LC_Recom_Rev_Adva_BPI',
  LC_Recom_Rev_Premier_BPI: 'LC_Recom_Rev_Premier_BPI',
  Nva_Rev_OH: 'Nva_Rev_OH',
  Refill_Nom_Mob: 'Refill_Nom_Mob',
  Refill_CP_Mob: 'Refill_CP_Mob',
};

export const SIMPLE_KRONER = {
  Simple_Nom_M: 'Simple_Nom_M',
  Simple_CP_M: 'Simple_CP_M',
  Simple_Nom_A: 'Simple_Nom_A',
  Simple_CP_A: 'Simple_CP_A',
  Simple_Nom_P: 'Simple_Nom_P',
  Simple_CP_P: 'Simple_CP_P',
  Simple_CP: 'Simple_CP',
  Simple_Nom: 'Simple_Nom',
  Simple_Nom_Saldos_P: 'Simple_Nom_Saldos_P',
  Simple_Nom_Mob: 'Simple_Nom_Mob',
  Simple_CP_Mob: 'Simple_CP_Mob',
  Simple_MenoresCP_Mob: 'Simple_MenoresCP_Mob',
  Simple_MenoresAN_Mob: 'Simple_MenoresAN_Mob',
  Pasivos_CP_Mob: 'Pasivos_CP_Mob',
  Pasivos_AN_Mob: 'Pasivos_AN_Mob',
};

export const TOP_UP_OHC = {
  Nva_TopUp: 'Nva_TopUp',
  Nva_TopUp_CP: 'Nva_TopUp_CP',
  TopUp_AN_MB: 'TopUp_AN_MB',
  TopUp_CP_MB: 'TopUp_CP_MB',
  TopUp_AN_Mob: 'TopUp_AN_Mob',
  TopUp_CP_Mob: 'TopUp_CP_Mob',
};

export const TOP_UP_KR = {
  TopUp_KR_PIB_AN: 'TopUp_KR_PIB_AN',
  TopUp_KR_PIB_CP: 'TopUp_KR_PIB_CP',
  TopUp_KR_MOB_AN: 'TopUp_KR_MOB_AN',
  TopUp_KR_MOB_CP: 'TopUp_KR_MOB_CP',
};
